import React from "react";
import { createRoot } from "react-dom/client";
import "./estilo.css";   // utilitários de layout — sem eles nada centraliza
import App from "./App";
import { temPendencias } from "./api";
import { fotosPendentes } from "./fotos";
import { ENDERECO_ANTIGO, destinoDaMudanca } from "./endereco";

const montar = () => createRoot(document.getElementById("raiz")!).render(
  <React.StrictMode><App /></React.StrictMode>,
);

/**
 * No endereço antigo, decide ANTES de desenhar a tela se já pode mudar.
 *
 * Antes de montar, e só na abertura: mudar no meio do uso levaria embora um
 * formulário que a pessoa está preenchendo. Com pendência, abre aqui mesmo —
 * a fila sobe durante o uso, e a mudança acontece na próxima abertura.
 *
 * A leitura do IndexedDB tem prazo. Se travar, a contagem vira NaN, que a
 * regra trata como "não sei": fica no antigo, que continua funcionando.
 */
async function pendentesNoAparelho(): Promise<number> {
  const prazo = new Promise<number>((ok) => setTimeout(() => ok(NaN), 2000));
  const contagem = fotosPendentes().then((f) => temPendencias() + f.length);
  return Promise.race([contagem, prazo]).catch(() => NaN);
}

if (location.hostname === ENDERECO_ANTIGO) {
  pendentesNoAparelho().then((n) => {
    const destino = destinoDaMudanca(location.hostname, n);
    if (destino) location.replace(destino); else montar();
  });
} else {
  montar();
}

/**
 * Registra o service worker, e só ele decide o que guardar.
 *
 * Depois do primeiro carregamento — não antes: registrar durante a
 * inicialização disputa banda com os pedidos que a tela precisa para
 * aparecer, e numa rede de galpão isso é a diferença entre abrir na hora e
 * parecer travado.
 *
 * Falhar aqui não é motivo para alarme: sem service worker o app funciona
 * como sempre funcionou, só não abre sem rede.
 */
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((e) => {
      console.warn("[pwa] service worker não registrou:", e?.message ?? e);
    });
  });
}
